import { CustomRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { Issue } from '../IssueTrackerContext/types'
import {
  IssueStatus,
  Permission,
  SharePointParentFolder,
} from '@cims-online/shared'
import { useIssueTrackerContext } from '../IssueTrackerContext'
import {
  useLockRowActionButton,
  useUnlockRowActionButton,
} from 'components/CIMSTable/common/hooks/useLockUnlock'
import { useClosedDisabledMessage } from 'components/CIMSTable/common/hooks/useClosedDisabledMessage'

export function useCustom(): CustomRowActionOptions<Issue>[] {
  const {
    revertModal,
    issues: { refetch },
  } = useIssueTrackerContext()
  const parent = SharePointParentFolder.Issues
  const lock = useLockRowActionButton<Issue>({
    refetch,
    parent,
    hidden: ({ statusId }) => statusId !== IssueStatus.Unlocked.id,
  })
  const unlock = useUnlockRowActionButton<Issue>({
    refetch,
    parent,
    hidden: ({ deleted, statusId }) =>
      deleted || statusId !== IssueStatus.Closed.id,
  })
  return [
    {
      type: 'button',
      permission: Permission.RevertIssue,
      onClick: (issue) => revertModal.toggle(issue),
      text: 'Revert',
      disabled: useClosedDisabledMessage('reverted', IssueStatus.Closed),
      hidden: ({ deleted, statusId }) =>
        deleted || statusId === IssueStatus.Draft.id,
    },
    unlock,
    lock,
  ]
}
